import {Box, Grid} from "@mui/system";
import style from "../../../assets/css/proposal.module.scss";
import {Link, useNavigate} from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Button,
  Breadcrumbs,
  Typography,
} from "@mui/material";
import {useFormik} from "formik";
import * as Yup from "yup";
import {useCallback, useEffect, useMemo, useState} from "react";
import {HiCurrencyDollar, HiOutlineClock} from "react-icons/hi2";
import GlobalDateField from "../../global-fields/GlobalDateField";
import GlobalTextField from "../../global-fields/GlobalTextField";
import GlobalSelectField from "../../global-fields/GlobalSelectField";
import GlobalModal from "../../global-fields/GlobalModal";
import {useDispatch, useSelector} from "react-redux";
import {selectAuthState} from "../../../store/authSlice";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import {SiAdobeacrobatreader} from "react-icons/si";
import {ERR_MESSAGE, MANDATORY_QUES} from "../../../constants/constants";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import {removeCookies} from "../../../constants/helper";
import {selectUiState, setUiData} from "../../../store/uiSlice";
import {
  AGENT_ENDORSEMENTS_LIST,
  ENDORSEMENT_LIST,
  ENDORSEMENTS,
  REQUEST_ENDORSEMENT,
} from "../../../constants/apiConstant";
import dayjs from "dayjs";
import GlobalTextAriaField from "../../global-fields/GlobalTextArea";
import EndorsementFormModal from "../../endorsement-form-modal/EndorsementFormModal";
import {BsCheckSquare, BsExclamationSquare} from "react-icons/bs";
import NoDataComponent from "../../no-data";

const columns0 = [
  {id: "id", label: "#", minWidth: 25},
  {id: "EndorsementID", label: "Endorsement ID", minWidth: 120},
  {id: "type", label: "Type", minWidth: 90},
  {id: "Date", label: "Date", minWidth: 80},
  {id: "status", label: "Status", minWidth: 100},
  // { id: "amount", label: "Hard Quote Amt", minWidth: 130 },
  // { id: "soft_quote", label: "Soft Quote Amt", minWidth: 110 },
  {id: "payment", label: "Payment", minWidth: 80},
  {id: "view", label: "View", minWidth: 80},
];

const agentColumns0 = [
  ...columns0.slice(0, 2),
  {
    id: "full_name",
    label: "Client Name",
    minWidth: 160,
    renderCell: (row) => row.full_name,
  },
  ...columns0.slice(2),
];
const rows = Array.from({length: 8}, (_, index) => ({
  id: index + 1,
  EndorsementID: "PROP10292024" + (index + 1),
  Date: "12/10/2025",
  Type: "Entrustment",
  amount: "$12,00" + index,
  soft_quote: "$14,00" + index,
  status: index == 0 ? 0 : index == 1 ? 1 : 2,
  payment: index == 0 ? 0 : index == 1 ? 1 : 2,
  view: "VIEW",
  payment_status: index == 0 ? 0 : index == 1 ? 1 : 2,
}));

//Exhibition, Stock Limit, Shipping, Other

const EndorsementsList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const isFirstRender = useRef(true);
  const {user} = useSelector(selectAuthState);
  const {endorsementList, endorsementCount, endorsementParentProposal} =
    useSelector(selectDataStoreState);
  const {showLoader} = useSelector(selectUiState);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  // const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);

  const endorseList = useMemo(
    () => (endorsementList?.length ? endorsementList : []),
    [endorsementList]
  );
  const currentRowData = useMemo(() => currentRow, [currentRow]);
  // console.log("endorsementParentProposal", endorsementParentProposal);

  const [openEndorseForm, setClaimForm] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const fetchEndorsements = useCallback(async () => {
    if (page === null || rowsPerPage === null) {
      return;
    }
    dispatch(setUiData({showLoader: true}));

    let data = {
      limit: rowsPerPage,
      offset: page * rowsPerPage,
      // proposal_id: endorsementParentProposal?.proposal_id
    };

    // let apiDetails =
    //   user?.user_type === "agent"
    //     ? {
    //         method: AGENT_ENDORSEMENTS_LIST.method,
    //         headers: AGENT_ENDORSEMENTS_LIST.headers,
    //         url: AGENT_ENDORSEMENTS_LIST.url,
    //       }
    //     : {
    //         method: ENDORSEMENT_LIST.method,
    //         headers: ENDORSEMENT_LIST.headers,
    //         url: ENDORSEMENT_LIST.url,
    //       };
    // if (user?.user_type === "agent") {
    //   data["agent_id"] = user?.id;
    // } else {
    //   data["proposal_id"] = endorsementParentProposal?.proposal_id;
    // }

    let apiDetails = {
      method: ENDORSEMENT_LIST.method,
      headers: ENDORSEMENT_LIST.headers,
      url: ENDORSEMENT_LIST.url,
    };

    data["proposal_id"] = endorsementParentProposal?.proposal_id;

    const options = {
      method: apiDetails.method,
      headers: apiDetails.headers,
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(apiDetails.url, options);
      const res = await response.json();
      if (res.status == 1) {
        dispatch(
          setDataStore({
            endorsementList: res?.endorsements_list || [],
            endorsementCount: res?.total_count || 0,
          })
        );
      } else {
        console.error("Error fetching endorsement");
      }
    } catch (error) {
      removeCookies("isLogin");
      GlobalNotificationPopup({type: "error", message: error});
      navigate("/");
    } finally {
      dispatch(setUiData({showLoader: false}));
    }
  }, [page, rowsPerPage, user]);

  useEffect(() => {
    // if (isFirstRender.current) {
    //   isFirstRender.current = false; // Prevent the second fetch caused by Strict Mode
    //   return;
    // }
    fetchEndorsements();
  }, [fetchEndorsements]);

  const handleSubmit = () => {
    setAnchorEl(null);
  };
  const handleClickOpenEndorseForm = (row) => {
    setCurrentRow(row);
    dispatch(
      setUiData({
        endorsementFormModal: true,
      })
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handlePDF = (row) => {
    // console.log(" PDF:", row?.policy_file);
    if (!row?.policy_file) {
      console.error("Invalid PDF URL");
      return;
    }
    window.open(row?.policy_file, "_blank");
  };

  const handlePayment = async (row) => {
    dispatch(
      setDataStore({
        checkoutData: {
          proposal_id: endorsementParentProposal?.proposal_id,
          id_forAPI: row.id,
          endorsement_id: row.endorsement_id,
          // hard_quote: row?.amount,
          formated_hard_quote: row?.formatted_amount,
          formated_hard_quote_with_Fee: row?.formatted_amount_with_fee,
          proposal_date: row?.date_reported,
          firm_name: row.firm_name,
        },
        checkoutRawData: row,
      })
    );
    navigate("/checkout");
  };

  const columns = [
    {
      id: "id",
      label: "#",
      minWidth: 50,
      renderCell: (_row, value) => value,
    },
    {
      id: "endorsement_id",
      label: "Endorse ID",
      minWidth: 100,
      renderCell: (row) => `${row.endorsement_id}`,
    },
    {
      id: "type",
      label: "Type",
      minWidth: 100,
    },
    {
      id: "formatted_amount",
      label: "Amount",
      minWidth: 100,
    },
    {
      id: "date_reported",
      label: "Date Reported",
      minWidth: 120,
    },
    {
      id: "date_from",
      label: "Date From",
      minWidth: 120,
    },
    {
      id: "date_to",
      label: "Date To",
      minWidth: 120,
    },
    {
      id: "status",
      label: "Status",
      minWidth: 120,
      renderCell: (row) => {
        const statusMap = {
          0: (
            <Button
              disabled
              style={{color: "#ff8607"}}
              className={style.IssuedPolicyBtnDanger}
            >
              In Progress
            </Button>
          ),
          1: (
            <Button
              disabled
              style={{color: "#00ba34"}}
              className={style.IssuedPolicyBtnSucces}
            >
              Approved
            </Button>
          ),
          2: (
            <Button
              disabled
              style={{color: "#ff3d32"}}
              className={style.IssuedPolicyBtnExpired}
            >
              Declined
            </Button>
          ),
        };
        return (
          statusMap[row.payment_status] || (
            <span style={{color: "#FF2116"}}>N/A</span>
          )
        );
      },
    },
    {
      id: "payment_status",
      label: "Payment",
      minWidth: 100,
      renderCell: (row) => {
        if (user?.user_type === "agent") {
          // if (row.amount == 0)
          //   return <span style={{ color: "#FF2116" }}>N/A</span>;
          if (row.payment_status == 0)
            return <HiOutlineClock color="#ff8607" size={28} />;
          if (row.payment_status == 1)
            return <BsCheckSquare color="#00BA34" size={24} />;
          if (row.payment_status == 2)
            return <BsExclamationSquare color="#FF2116" size={24} />;
          return <span style={{color: "#FF2116"}}>N/A</span>;
        } else {
          return row.payment_status == 1 ? (
            <BsCheckSquare color="#00BA34" size={24} />
          ) : (
            <Button
              variant="contained"
              color="primary"
              size="small"
              style={{
                marginRight: 8,
                background: row.amount == 0 ? "#f1f1f1" : "#004F71",
              }}
              disabled={row.amount == 0}
              onClick={() => handlePayment(row)}
            >
              <HiCurrencyDollar />
              Pay
            </Button>
          );
        }
      },
    },
    {
      id: "pdf",
      label: "View",
      minWidth: 100,
      renderCell: (row) => (
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={{
            marginRight: 8,
            background: "#F5F5F5",
            color: "#2C2C2C",
            padding: "4px 15px",
            border: "1px solid rgba(0, 0, 0, 0.11)",
          }}
          onClick={() => handlePDF(row)}
        >
          <SiAdobeacrobatreader
            style={{marginRight: "7px", fontSize: "18px"}}
            color="#FF2116"
          />
          PDF
        </Button>
      ),
    },
  ];

  const agentColumns = [
    ...columns.slice(0, 2),
    {
      id: "company",
      label: "Company Name",
      minWidth: 160,
      renderCell: (row) => row.company,
    },
    // {
    //   id: "full_name",
    //   label: "Client Name",
    //   minWidth: 160,
    //   renderCell: (row) => row.full_name,
    // },
    ...columns.slice(2),
  ];
  return (
    <>
      <Grid
        container
        spacing={3}
        className="customeContainer"
        justifyContent="center"
      >
        <Grid size={{xs: 12, lg: 12}} sx={{mt: 2}}>
          <div className={style.propPagination}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" to="/dashboard">
                Dashboard
              </Link>
              <Link underline="hover" color="inherit" to="/issued-policy">
                Issued Policies
              </Link>

              <Typography sx={{color: "grey"}}> Endorsements </Typography>
            </Breadcrumbs>
          </div>
        </Grid>
      </Grid>

      <section className={style.ProposalUnderProgessSection}>
        <Grid
          container
          spacing={3}
          className="customeContainer"
          justifyContent="center"
        >
          <Grid size={{xs: 12, lg: 12}}>
            <div className={style.propUnderProgTitle}>
              <div className={style.EndorsementsListTitle}>
                <h3> Endorsements List</h3>
                <p>
                  Policy Number:
                  <span> {endorsementParentProposal?.policy_number}</span>
                </p>
              </div>
              <Button
                sx={{
                  background: "rgb(0, 79, 113)",
                  textTransform: "capitalize",
                }}
                variant="contained"
                onClick={() => handleClickOpenEndorseForm()}
              >
                Request New
              </Button>
            </div>

            <Paper className={style.propTableMain} sx={{mt: 1}}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      {(user?.user_type === "agent"
                        ? agentColumns
                        : columns
                      ).map((column) => (
                        <TableCell
                          style={{minWidth: column.minWidth}}
                          key={column.id}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                      {/* <TableCell> Actions </TableCell> */}
                    </TableRow>
                  </TableHead>
                  {endorseList?.length > 0 ? (
                    <TableBody>
                      {endorseList.map((row, rowIndex) => (
                        <TableRow key={row.id}>
                          {(user?.user_type === "agent"
                            ? agentColumns
                            : columns
                          ).map((column) => {
                            let value =
                              column.id === "id"
                                ? rowIndex + 1
                                : row[column.id];
                            return (
                              <TableCell
                                key={column.id}
                                style={{minWidth: column.minWidth}}
                              >
                                {column.renderCell
                                  ? column.renderCell(row, value)
                                  : value}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))}
                    </TableBody>
                  ) : null}
                </Table>
                {endorseList?.length > 0
                  ? null
                  : !showLoader && <NoDataComponent />}
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 15]}
                component="div"
                count={endorsementCount || 0} // Use correct count
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                disabled={!endorseList.length}
              />
            </Paper>
          </Grid>
        </Grid>
      </section>

      <EndorsementFormModal fetchListAgain={() => fetchEndorsements()} />
    </>
  );
};

export default EndorsementsList;
